import React from 'react';
import {useParams} from 'react-router-dom';
import Requirements from "./Requirements";

// TODO This is a temporary workaround since Requirements doesn't use effects.
const RequirementsMode = (props) => {
    let params = useParams();
    console.log("RequirementsMode:", params);

    return (
       <Requirements
           globals={props.globals}
           user={props.user}
           metamodel={props.metamodel}
           mode={params.mode}
           product="1"
           showTasksInTree={false}/>
    );
};

export default RequirementsMode;
